import { Box } from '@palmetto/palmetto-components';

import { OrganizationStatus, OrganizationStatusLabels } from 'types';

import EventBy, { ActivityEvent } from './EventBy';

export interface OrganizationStatusChangedProps extends ActivityEvent {
  data: {
    oldStatus: string;
    newStatus: string;
    description?: string;
  };
}

const OrganizationStatusChanged = ({ event }: { event: OrganizationStatusChangedProps }) => {
  const oldStatusLabel =
    OrganizationStatusLabels[event.data.oldStatus as OrganizationStatus] ?? OrganizationStatusLabels.unknown;
  const newStatusLabel =
    OrganizationStatusLabels[event.data.newStatus as OrganizationStatus] ?? OrganizationStatusLabels.unknown;

  return (
    <Box display="block">
      <EventBy event={event} /> changed organization status from <strong>{oldStatusLabel}</strong> to{' '}
      <strong>{newStatusLabel}</strong>
      {event.data.description && <Box>Description: {event.data.description}</Box>}
    </Box>
  );
};

export default OrganizationStatusChanged;
